import * as React from 'react';
import logo from '@/assets/ww-logo.png';

/** Festival logo wordmark — transparent-background cut-out, floats on any color. */
export function Logo({
  h = 46,
  className,
  style = {},
}: {
  h?: number;
  className?: string;
  style?: React.CSSProperties;
}) {
  return (
    <img
      src={logo}
      alt="Wüst und Wild"
      className={className}
      style={{ height: h, width: 'auto', display: 'block', ...style }}
    />
  );
}
